<div class="data-filter">
    <label [i18n]="[{target: 'innerHTML', key: labelKey}]"></label>
    <span *ngIf="required" class="required-asterisk">*</span>
    <input [type]="isNumber ? 'number': 'text'" class="form-control"
           [(ngModel)]="model"
           [i18n]="[{target: 'attribute:placeholder', key: placeholderKey}]"
           [disabled]="disabled"
           [min]="isNumber ? min : ''"
           [max]="isNumber ? max : ''"
           [step]="isNumber ? step : ''"
           (ngModelChange)="change()">
    <span *ngIf="helperKey">
        <i class="fa fa-info-circle"></i>
        <small [i18n]="helperKey"></small>
    </span>
</div>
